<template>
<div class="password">
        <OtherHead :tipText="$t('没有访问权限')"></OtherHead>
        <div class="empty_content">
            <img src="@/assets/img/other/password.png" alt=""/>
            <div class="empty_text">{{$t("该文件需要密码")}}</div>
            <div class="password_text">{{$t("密码")}}                <a-input-password class="input_wrap" @press-enter="submit" @input="setPassword" :style="{ width: '184px' }" :placeholder="$t('请输入密码')" allow-clear></a-input-password>
            </div>
            <div class="submit" @click="submit">{{$t("确认")}}</div>
        </div>
    </div>
</template>

<script lang="ts">
import OtherHead from './OtherHead.vue';
export default {
    name: 'no_limit',
    components: {
        OtherHead
    },
    data() {
        return {
            password: ''
        };
    },
    computed: {},
    methods: {
        setPassword(val) {
            this.password = val;
        },
        submit() {
            console.log('this.password', this.password);
            this.$emit('submit_password', this.password);
        }
    }
};
</script>

<style lang="scss" scoped>
.password {
    flex: 1;
    display: flex;
    flex-direction: column;

    .empty_content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        img {
            width: 148px;
        }

        .empty_text {
            height: 25px;
            line-height: 25px;
            font-weight: 600;
            font-size: 18px;
            color: #121317;
            letter-spacing: 0;
            text-align: center;
        }

        .password_text {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;

            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #323233;
            height: 32px;

            .input_wrap {
                margin-left: 8px;
                background: #ffffff;
                border: 1px solid #e6e8ec;
                border-radius: 4px;

                input::placeholder {
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    color: #c8c9cc;
                }
            }
        }

        .submit {
            cursor: pointer;
            margin-top: 40px;
            width: 138px;
            height: 36px;
            background: #5c70ff;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;

            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 14px;
            color: #ffffff;
        }
    }
}
</style>
